/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

import React from "react";
import { NavLink } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import logo from "../../Images/logo.png";

const Header = () => {

  const navStyle = ({ isActive }) => ({
    textDecoration: "none",
    color: "#fff",
    fontWeight: "600",
    letterSpacing: "1px",
    paddingBottom: "6px",
    position: "relative",
    transition: "all 0.4s ease",
    borderBottom: isActive
      ? "2px solid #ffffff"
      : "2px solid transparent",
  });

  const closeMenu = () => {

    const navbar =
      document.getElementById("navbarMenu");

    if (
      navbar &&
      navbar.classList.contains("show")
    ) {
      navbar.classList.remove("show");
    }

  };

  const handleNavClick = () => {

    closeMenu();

    window.scrollTo({
      top:0,
      behavior:"smooth",
    });

  };

  return (
    <>
      <style>
        {`
          @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@500;600;700&family=Manrope:wght@400;500;600;700&display=swap');

          .premium-navbar{

            width:100%;
            z-index:1000;
            position:fixed;
            top:0;
            left:0;
            height:90px;

            background:
              linear-gradient(
                to right,
                rgba(5,5,5,0.96),
                rgba(16,16,16,0.96),
                rgba(5,5,5,0.96)
              );

            backdrop-filter:blur(18px);

            border-bottom:
              1px solid rgba(255,255,255,0.08);

            box-shadow:
              0 8px 30px rgba(0,0,0,0.45);

            padding:14px 0;

            transition:all .4s ease;
          }

          .premium-navbar .nav-link{
            font-family:'Manrope',sans-serif;
            font-size:15px;
            position:relative;
          }

          /* UNDERLINE */

          .premium-navbar .nav-link::after{

            content:'';
            position:absolute;
            left:0;
            bottom:-2px;
            width:0%;
            height:2px;
            background:#ffffff;
            transition:.4s ease;
          }

          .premium-navbar .nav-link:hover::after{
            width:100%;
          }

          .premium-navbar .nav-link:hover{
            color:#ffffff !important;
            transform:translateY(-2px);
          }

          /* LOGO */

          .logo-image{
            height:82px;
            object-fit:contain;
            transition:all .4s ease;
            filter:
              drop-shadow(
                0 0 18px rgba(255,255,255,0.12)
              );
          }

          .logo-image:hover{
            transform:scale(1.04);
          }

          .brand-text{
            font-family:
              'Cormorant Garamond',
              serif;

            font-size:30px;
            font-weight:700;
            letter-spacing:1px;
            color:white;
          }

          .book-btn{

            background:#ffffff;
            color:#000;
            padding:14px 24px;
            text-decoration:none;
            font-weight:700;
            letter-spacing:.5px;
            transition:all .45s ease;
            display:inline-block;

            border:
              1px solid rgba(255,255,255,0.08);

            box-shadow:
              0 10px 30px rgba(255,255,255,0.08);

            border-radius:10px;
          }

          .book-btn:hover{

            transform:
              translateY(-4px)
              scale(1.03);

            box-shadow:
              0 18px 40px rgba(255,255,255,0.18);

            color:#000;
          }

          @media (max-width:991px){

            .premium-navbar{
              height:110px;
              padding:12px 0;
            }

            .navbar-brand{
              display:flex !important;
              align-items:center !important;
              gap:10px !important;
              margin-left:0 !important;
            }

            .logo-image{
              height:58px;
            }

            .brand-text{
              font-size:22px;
              line-height:1;
              margin:0;
            }

            .navbar-nav{
              flex-direction:row !important;
              justify-content:flex-end;
              align-items:center;
              gap:12px !important;
            }

            .premium-navbar .nav-link{
              font-size:13px;
              padding:0 !important;
            }

            .mobile-menu{
              display:flex !important;
              justify-content:flex-end;
            }

            .navbar-collapse{
              display:block !important;
            }

            .navbar-toggler{
              display:none !important;
            }

            .book-btn{
              padding:10px 14px;
              font-size:11px;
            }

          }

    @media (max-width:768px){

  .premium-navbar{
    min-height:92px;
    padding:10px 0;
  }

  .premium-navbar .container{
    flex-direction:row;
    justify-content:center !important;
    align-items:center !important;
    gap:10px;
  }
  .book-btn{
  padding:4px 10px !important;
  font-size:10px !important;
  height:28px !important;
  display:flex;
  align-items:center;
  justify-content:center;
  border-radius:20px;
}

  .premium-navbar{
    min-height:72px;
    padding:8px 0;
  }

  .logo-image{
    height:34px;
  }

  .brand-text{
    font-size:14px;
  }

  .navbar-nav{
    gap:12px !important;
  }

  .premium-navbar .nav-link{
    font-size:11px;
  }
  .navbar-brand{
    margin-left:0 !important;
    gap:8px !important;
  }

  .logo-image{
    height:42px;
  }

  .brand-text{
    font-size:17px;
    margin:0;
    line-height:1;
  }

  .mobile-menu{
    display:block !important;
    width:100%;
  }

  .navbar-collapse{
    display:block !important;
  }

  .navbar-nav{
    flex-direction:row !important;
    justify-content:center !important;
    align-items:center;
    gap:14px !important;
    width:100%;
  }

  .premium-navbar .nav-link{
    font-size:12px;
    padding:0 !important;
  }

  .book-btn{
    padding:8px 14px;
    font-size:11px;
    border-radius:30px;
  }

  .nav-item.mt-3{
    margin-top:0 !important;
  }

}

}
        `}
      </style>

      <nav className="navbar navbar-expand-lg premium-navbar">

        <div className="container">

          {/* LOGO */}

          <NavLink
            className="navbar-brand"
            to="/"
            style={{
              display:"flex",
              alignItems:"center",
              gap:"12px",
              marginLeft:"20px",
            }}
          >

            <img
              src={logo}
              alt="logo"
              className="logo-image"
            />

            <h3 className="brand-text">
              Arson's Beauty Zone
            </h3>

          </NavLink>

          {/* HAMBURGER */}

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarMenu"
            aria-controls="navbarMenu"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* MENU */}

          <div
            className="collapse navbar-collapse mobile-menu"
            id="navbarMenu"
          >

            <ul
              className="
                navbar-nav
                ms-auto
                gap-lg-5
                text-center
                align-items-center
              "
            >

              <li className="nav-item">

                <NavLink
                  to="/"
                  style={navStyle}
                  className="nav-link"
                  onClick={handleNavClick}
                >
                  Home
                </NavLink>

              </li>

              <li className="nav-item">

                <NavLink
                  to="/services"
                  style={navStyle}
                  className="nav-link"
                  onClick={handleNavClick}
                >
                  Services
                </NavLink>

              </li>

              <li className="nav-item">

                <NavLink
                  to="/bridal"
                  style={navStyle}
                  className="nav-link"
                  onClick={handleNavClick}
                >
                  Gallery
                </NavLink>

              </li>

              <li className="nav-item">

                <NavLink
                  to="/contact"
                  style={navStyle}
                  className="nav-link"
                  onClick={handleNavClick}
                >
                  Contact
                </NavLink>

              </li>

              {/* BUTTON */}

              <li className="nav-item mt-3 mt-lg-0">

                <a
                  href="https://wa.me/916394941232"
                  target="_blank"
                  rel="noreferrer"
                  className="book-btn"
                >
                  Book Now
                </a>

              </li>

            </ul>

          </div>

        </div>

      </nav>
    </>
  );
};

export default Header;